import React, { createContext, useEffect, useContext, useState } from 'react';
import { getApiService } from '../services/ApiService';
import Cookies from 'js-cookie';

/**
 * This context used to get sso external logout content message
 */
export const LogoutContentContext = createContext();

export const LogoutContentProvider = ({children}) => {

    //Find page from URL
    const findPage = () => {
        const pathName = window.location.pathname;
        const page = pathName.startsWith('/') ? pathName.slice(1) : pathName;
        return page ? page : 'logout';
    }
    // Find SiteCd from localStorage
    const findSiteCd = () => {
        const appData = localStorage.getItem('appData');
        const decodedData = appData ? JSON.parse(atob(appData)) : null;
        let siteCd = '';
        if (decodedData && typeof decodedData === 'object' && !Array.isArray(decodedData)) {
            const values = Object.values(decodedData);
            if (values.length && typeof values[0] === 'object' && values[0] !== null && 'site_cd' in values[0]) {
                siteCd = values[0].site_cd;
            } else if ('site_cd' in decodedData) {
                siteCd = decodedData.site_cd;
            }
        }
        return siteCd;
    }
    const [logoutContent, setLogoutContent] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const headers = {
                "X-Hps-Client-Id": process.env.REACT_APP_API_CLIENT_ID,
                "X-Hps-Secret-Id": process.env.REACT_APP_API_SECRET_ID,
                };
    const targetUrl = process.env.REACT_APP_API_CMS_CONTENT_ENDPOINT;
    const lang = Cookies.get('lang') || 'eng';
    
    useEffect(() => {
        const siteCd = findSiteCd(); 
        const page = findPage();   
        getApiService(
            baseUrl,
            targetUrl,
            {
                page: page,
                site_cd: siteCd ? siteCd : 'CGMBR',
                lang: lang
            },
            headers
        ).then((response) => {
            if(response?.data && response.data.status === 'SUCCESS'){
                const result = response.data.data;
                setLogoutContent(result);
            }
        }).catch((error) => {
            console.log(error);
        });
    }, [lang]);
    
    return (
        <LogoutContentContext.Provider value={{logoutContent}}>
            {children}
        </LogoutContentContext.Provider>
    );
}

export const useLogoutContent = () => useContext(LogoutContentContext);